<template>
  <div class="main">
    <div class="row m-2">
      <router-link
        class="btn btn-info m-2"
        :to="`/dashboard/create-institution-charge`"
      >
        Create Charge
      </router-link>
      <div class="p-4 col-12">
        <button class="btn btn-info" @click="refresh('refresh')">
          Refresh
        </button>
      </div>

      <div class="spinner-grow" role="status" v-if="loading === true"></div>
      <div class="alert alert-danger" role="alert" v-if="error === true">
        {{ errorMsg }}
      </div>
      <!-- <h4>Transactions</h4> -->

      <div class="col-12">
        <card class="card-plain">
          <div class="table-full-width table-responsive">
            <table class="table">
              <thead class="thead-dark">
                <tr>
                  <th scope="col" class="text-center">S/N</th>
                  <th scope="col" class="text-center">Product</th>
                  <th scope="col" class="text-center">Fee</th>
                  <th scope="col" class="text-center">Type</th>
                  <th scope="col" class="text-center">Mode</th>
                  <th scope="col" class="text-center">Min Amount</th>
                  <th scope="col" class="text-center">Max Amount</th>
                  <th scope="col" class="text-center">Merchant Name</th>
                  <th scope="col" class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(charge, index) in charges" :key="charge._id">
                  <th class="text-center">
                    {{ index + 1 }}
                  </th>
                  <td class="text-center">{{ charge.product }}</td>
                  <td class="text-center">{{ charge.fee }}</td>
                  <td class="text-center">{{ charge.type }}</td>
                  <td class="text-center">{{ charge.mode }}</td>
                  <td class="text-center">
                    {{ format.format(charge.minAmount || 0) }}
                  </td>
                  <td class="text-center">
                    {{ format.format(charge.maxAmount || 0) }}
                  </td>
                  <td class="text-center">
                    {{
                      charge.institutionId
                        ? charge.institutionId.institutionName
                        : "N/A"
                    }}
                  </td>
                  <td class="text-center">
                    <drop-down class="nav-item" title="Options" id="list">
                      <div class="p-2">
                        <router-link
                          :to="`/dashboard/institution-charge/${charge._id}`"
                        >
                          View charge
                        </router-link>
                      </div>
                    </drop-down>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "../store/axios";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      error: false,
      errorMsg: "",
      loading: false,
      charges: [],
      format: new Intl.NumberFormat("en-US"),
    };
  },
  methods: {
    ...mapActions(["setNotification"]),
    async refresh() {
      this.loading = true;
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/institution/charges/get-institution-charge`,
        );
        const { charges, message } = res.data;
        this.charges = charges;
        this.setNotification({
          type: "success",
          message,
        });
      } catch (error) {
        if (error.response && error.response.data) {
          const { message } = error.response.data;
          this.setNotification({ type: "danger", message });
        } else {
          this.setNotification({
            type: "danger",
            message: "Unable to Fetch Charges",
          });
        }
      }
      this.loading = false;
    },
  },
  async mounted() {
    this.loading = true;
    try {
      const res = await axios.get(
        `${process.env.VUE_APP_API_URL}/institution/charges/get-institution-charge`,
      );
      const { charges, message } = res.data;
      this.charges = charges;
      this.setNotification({
        type: "success",
        message,
      });
    } catch (error) {
      if (error.response && error.response.data) {
        const { message } = error.response.data;
        this.setNotification({ type: "danger", message });
      } else {
        this.setNotification({
          type: "danger",
          message: "Unable to Fetch Charges",
        });
      }
    }
    this.loading = false;
  },
};
</script>
<style scoped>
.transaction {
  font-size: 12px;
}
th {
  font-size: 12px !important;
}
.spinner-grow {
  position: fixed;
}
#list {
  list-style-type: none;
}
tbody {
  background: #fff !important;
}
.list {
  list-style-type: none;
}
</style>
